import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { SlabRate } from 'utils/types';
import { SlabRatePayload } from './useAddSlabRate';

interface UpdateSlabRate extends SlabRatePayload {
  id: number;
}

const updateSlabRate = async (data: UpdateSlabRate) => {
  const response = await axiosInstance.put(
    `/offence/slabRate/${data.id}`,
    data,
  );
  return response.data;
};

const useUpdateSlabRate = (): UseMutationResult<
  SlabRate,
  Error,
  UpdateSlabRate
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSlabRate,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['slabRates', variables.offenceId],
      });
    },
    onError: (error: Error) => {
      console.error('Error updating slab rate:', error.message);
    },
  });
};

export default useUpdateSlabRate;
